import { z } from "zod";

const clientEnvironmentSchema = z.object({
  VITE_API_BASE_URL: z.string().url().optional().or(z.literal("")),
}).passthrough();

const clientEnvironment = clientEnvironmentSchema.parse(import.meta.env);

export function apiUrl(path: `/${string}`) {
  const baseUrl = clientEnvironment.VITE_API_BASE_URL?.replace(/\/$/, "");
  return baseUrl ? `${baseUrl}${path}` : path;
}
